import axios, { AxiosError } from "axios";
import { getSession } from "../session/session";
import { defaultSession, SessionData } from "../session/lib";

const axiosBaseURL = axios.create({
  baseURL: process.env.REACT_APP_FABRIO_API_BASE,
});

export async function LoginAPI(userName: string, password: string) {
  let data = JSON.stringify({
    userName,
    password,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: process.env.REACT_APP_LOGIN_API,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      //   console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetFinancialYearAPI() {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: process.env.REACT_APP_GET_FIN_YEAR_API,
    headers: {},
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      //   console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetWcsDataAPI() {
  let session = await getSession().then((sess) => {
    let data: SessionData = sess ? JSON.parse(sess) : defaultSession;
    return data;
  });

  let url;
  if (session.userType === "Customer") {
    url = `${process.env.REACT_APP_WCS_BY_PARTY_API}?partyCode=${session.partyCode}`;
  } else {
    url = process.env.REACT_APP_WCS_ALL_API;
  }

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url,
    headers: {
      Authorization: `Bearer ${session.accessToken}`,
    },
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetFirDataAPI() {
  let session = await getSession().then((sess) => {
    let data: SessionData = sess ? JSON.parse(sess) : defaultSession;
    return data;
  });

  let url;
  if (session.userType === "Customer") {
    url = `${process.env.REACT_APP_FIR_BY_PARTY_API}?partyCode=${session.partyCode}`;
  } else {
    url = process.env.REACT_APP_FIR_ALL_API;
  }

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url,
    headers: {
      Authorization: `Bearer ${session.accessToken}`,
    },
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetForDataAPI() {
  let session = await getSession().then((sess) => {
    let data: SessionData = sess ? JSON.parse(sess) : defaultSession;
    return data;
  });

  let url;
  if (session.userType === "Customer") {
    url = `${process.env.REACT_APP_FOR_BY_PARTY_API}?partyCode=${session.partyCode}`;
  } else {
    url = process.env.REACT_APP_FOR_ALL_API;
  }

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url,
    headers: {
      Authorization: `Bearer ${session.accessToken}`,
    },
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetJoStatusMasterAPI() {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: process.env.REACT_APP_GET_JO_STATUS_MASTER_API,
    headers: {},
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetJobworkDetailByJoNoAPI(joNo: string) {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_GET_JOBWORK_DETAILS_API}/${joNo}`,
    headers: {},
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function UploadJobworkImageAPI(
  joNo: string,
  oSno: number,
  statusType: string,
  imageData: string,
  remarks: string,
) {
  let data = JSON.stringify({
    statusType,
    imageData,
    remarks
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_UPLOAD_JOBWORK_IMAGE_API}/${joNo}/${oSno}`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function GetJobworkStatusImageAPI(
  joNo: string,
  oSno: number,
  statusCode: string
) {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_GET_JOBWORK_STATUS_IMAGE_API}/${joNo}/${oSno}?statusCode=${statusCode}`,
    headers: {},
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}

export async function DeleteJobworkImageAPI(
  joNo: string,
  oSno: number,
  statusCode: string
) {
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_DELETE_JOBWORK_IMAGE_API}/${joNo}/${oSno}?statusCode=${statusCode}`,
    headers: {},
  };

  const result = axiosBaseURL
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      return JSON.stringify(response.data);
    })
    .catch((error: AxiosError) => {
      console.log(error.message);
      return JSON.stringify(error.response?.data);
    });

  return result;
}
